import React, { useEffect } from "react";

// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { Loader, PageOverLay, SEO, TrainingInfo } from "..";

export const TrainingAll = () => {
  const checkServices = useStore((state) => state.checkServices);
  const getLink = useStore((state) => state.getLink);
  const loading = useStore((state) => state.loading);
  const trainingDetails = useStore((state) => state.trainingDetails);

  useEffect(() => {
    checkServices(trainingDetails);
  }, []);
  const overlay = {
    where: "trainingAll",
    title: "Training",
    caption:
      "A dog learning to calmly ride in a shopping cart during a public outing with their owner.",
  };
  const info = {
    routes: {
      Home: "/",
      Training: getLink(pathTitles.TRAINING),
    },
    body: trainingDetails.ALLTRAININGPROGRAMS.body,
  };
  return (
    <>
      <SEO
        title="All Dog Training Programs"
        description="Explore every dog training program at Todo's Translator — private in-home lessons, day training, board & train for adults and puppies, boarding, and trained puppies. Serving Indianapolis and surrounding areas."
        path="/training/all"
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          <PageOverLay overlay={overlay} />
          <TrainingInfo info={info} />
        </>
      )}
    </>
  );
};
